import React from "react"
import {Deal, PaymentCurrencyType} from "@irati/types"
import {PerksPaymentSelectOnChange} from "@shared/payments/types"
import FormattedMessage from "@irati/utils/lang"
import {H1} from "@irati/ui/src/Typography"
import PerksPaymentSelect from "@irati-web/payments/src/components/PerksPaymentSelect"
import PayByUserWallet from "@irati-web/payments/src/components/PayByUserWallet"
import withPerkOrReward, {WithPerkOrReward} from "@irati-web/flexi-rewards/src/utils/withPerkOrReward"

interface Props extends WithPerkOrReward {
  deal: Deal
  onPaymentChange: PerksPaymentSelectOnChange
  hideTitle?: boolean
}

const PaymentSelect: React.FC<Props> = ({deal, onPaymentChange, isRewards, hideTitle}) => {
  const {isTTDeal} = deal
  const title = isTTDeal ? "perks.containers.paymentOrder.payWithFlexiPoints" : "perks.containers.paymentOrder.paymentOption.title"

  return (
    <>
      {!hideTitle && (
        <H1>
          <FormattedMessage id={title} />
        </H1>
      )}
      {isRewards && <PayByUserWallet onChange={onPaymentChange} currency={PaymentCurrencyType.Rp} />}
      {isTTDeal && <PayByUserWallet onChange={onPaymentChange} currency={PaymentCurrencyType.Tt} />}
      {!isTTDeal && !isRewards && <PerksPaymentSelect deal={deal} onChange={onPaymentChange} />}
    </>
  )
}

export default withPerkOrReward(PaymentSelect)
